export default {
  GET_USER(state, data) { state.user = data; },
  SET_DISPLAY_LOGIN_MODAL(state, data) { state.displayLoginModal = data; },
  HAVE_NOTES(state, data) { state.haveNotes = data; },
  UPDATE_NICK(state, data) { state.nick = data; },
  SET_INVITE(state, data) { state.invite = data; },
  PUSH_FRIENDS_DATA(state, data) { state.friendsData = data; },
};
